import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../store/store';
import {
  selectCurrentTemplateId,
  selectIsDrawerOpen,
  setCurrentTemplateId,
  setIsDrawerOpen,
  clearCurrentTemplate,
} from '../../store/stylist/slice';

const useSyncWithUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isDrawerOpen = useAppSelector(selectIsDrawerOpen);
  const currentTemplateId = useAppSelector(selectCurrentTemplateId);

  const params = new URLSearchParams(location.search);
  const templateIdFromUrl = params.get('templateId');

  useEffect(() => {
    // If URL has templateId but drawer is not open, open it
    if (templateIdFromUrl && !isDrawerOpen) {
      const id = parseInt(templateIdFromUrl, 10);
      if (!isNaN(id)) {
        dispatch(setCurrentTemplateId(id));
        dispatch(setIsDrawerOpen(true));
      }
    }

    // If URL doesn't have templateId but drawer is open with a template, update URL
    if (!templateIdFromUrl && isDrawerOpen && currentTemplateId) {
      const newParams = new URLSearchParams(location.search);
      newParams.set('templateId', currentTemplateId.toString());
      navigate(`${location.pathname}?${newParams.toString()}`, {
        replace: true,
      });
    }

    // If URL has different templateId than current, sync it
    if (
      templateIdFromUrl &&
      currentTemplateId &&
      parseInt(templateIdFromUrl, 10) !== currentTemplateId
    ) {
      const id = parseInt(templateIdFromUrl, 10);
      if (!isNaN(id)) {
        dispatch(setCurrentTemplateId(id));
      }
    }
  }, [templateIdFromUrl, isDrawerOpen, currentTemplateId, dispatch, navigate, location]);

  const openCreateDrawer = () => {
    dispatch(setCurrentTemplateId(null));
    dispatch(clearCurrentTemplate());
    dispatch(setIsDrawerOpen(true));

    // Remove templateId from URL when creating
    const newParams = new URLSearchParams(location.search);
    newParams.delete('templateId');
    const queryString = newParams.toString();
    navigate(`${location.pathname}${queryString ? `?${queryString}` : ''}`, {
      replace: true,
    });
  };

  const closeDrawer = () => {
    dispatch(setIsDrawerOpen(false));
    dispatch(setCurrentTemplateId(null));
    dispatch(clearCurrentTemplate());

    // Remove templateId from URL when closing
    const newParams = new URLSearchParams(location.search);
    newParams.delete('templateId');
    const queryString = newParams.toString();
    navigate(`${location.pathname}${queryString ? `?${queryString}` : ''}`, {
      replace: true,
    });
  };

  return {
    openCreateDrawer,
    closeDrawer,
    isDrawerOpen,
  };
};

export default useSyncWithUrl;
